export default {"src":"/_next/static/media/Picture.c80c0d03.svg","height":25,"width":25};